import React from 'react'
import { SVGIcon } from '~/utils/types'


export const LaboTank = (props: SVGIcon) => (
  <svg
    {...props}
    width="32px"
    height="32px"
    viewBox="0 0 32 32"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill="none"
      d="M23.1655945,29.1418817 L15.0625814,29.1418817 M23.1655945,26.1418817 L15.0625814,26.1418817 M23.1655945,23.149632 L15.0625814,23.149632 M30,31.8581183 L2,31.8581183 M11.6649023,12.0772546 L10.3660831,12.0772546 C9.83908795,12.0772546 9.41184853,12.5026159 9.41184853,13.0272945 L9.41184853,31.8581183 M11.4756515,9.41470249 L9.385057,9.41470249 C7.96539088,9.41470249 6.81449511,10.5602554 6.81449511,11.9736809 L6.81478013,13.4149153 L6.81478013,31.8581183 M13.4416938,31.8581183 L13.4416938,23.8148444 L13.4416938,6.88920812 C13.4416938,5.30665957 15.0101384,2.28287665 18.8746743,2.1622772 L19.3535016,2.1622772 C23.2183225,2.27436375 24.7864821,5.09809346 24.7864821,6.9638379 L24.7864821,31.8581183 M14.5216205,1.77352133 L14.5216205,0 L23.7065554,0 L23.7065554,1.77352133"
      id="Stroke-1"
      stroke="#FFF"
      stroke-linecap="round"
      stroke-linejoin="round"
    ></path>
  </svg>
)
